// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__20U5b","footer":"ModalError_footer__3kmHc"};